import { DataBean } from "../DataBean";


export class HiringDocumentStage extends DataBean {

    public async renderHiringDocumentStage(idstage: any, statedoc: any): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_renderHiringDocumentStage_Number_Number", [idstage, statedoc]);
    }

    public async getHiringModalityDocumentRender(page: number, recordsPerPage: number, props: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getHiringModalityDocumentRender_Number_Number_java.util.Map", [page, recordsPerPage, props]);
    }

}